import { UserWrapper } from '@core';

export class ChronodriveUserWrapper extends UserWrapper {
  // TODO
  analyticsAllowed() {
    return true;
  }
  
  // TODO
  profilingAllowed() {
    return true;
  }

  isUserLogged() {
    return !!this.getUserId();
  }

  getUserId() {
    const matcher = document.cookie.match(/chronoUser="userId=([0-9]+)";/);
    return matcher && matcher[1];
  }

  getUserPwd() {
    return localStorage.getItem('_miam/userPwd');
  }

  // Catch user password at login (from form)
  interceptUserPwd() {
    let oldXHRSend = window.XMLHttpRequest.prototype.send;
    
    window.XMLHttpRequest.prototype.send = function (data) {
      this.addEventListener('load',
        function (_loadEvent) {
          if (this.responseURL.match('login.connexion.login.loginform')) {
            const pwd = data.match(/pwd_login=(.+)&/)[1];
            localStorage.setItem('_miam/userPwd', pwd);
            console.debug("[Miam] User pwd saved");
          }
        }
      );

      return oldXHRSend.apply(this, arguments);
    }
  }

  // TODO: cache token ?
  static getAuthToken(callback) {
    // TODO: use static methods
    const wrapper = new ChronodriveUserWrapper();
    const id = wrapper.getUserId();
    const pwd = wrapper.getUserPwd();

    if (!id || !pwd) {
      console.debug('[Miam] Cannot get auth token as user is not logged in');
      localStorage.removeItem('_miam/userPwd')
      return callback(null);
    }

    let req = new XMLHttpRequest();
    const params = `v2=true&login=${id}&password=${pwd}`;

    req.addEventListener('load', function(_event) {
      // Logged in, pass auth token back
      callback(JSON.parse(this.responseText)['token']);
    })
    req.open('post', 'https://www.chronodrive.com/mobile/ws/login', true);
    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    return req.send(params);
  }
}
